import React from "react";
import { Modal } from "react-bootstrap";
import SecondaryButton from "../../Buttons/SecondaryButton";

const ProfileCompleteAlert = ({
  isOpen,
  toggleModal,
  nextText,
  text,
  imgSrc,
}) => {
  return (
    <Modal
      centered
      show={isOpen}
      onHide={toggleModal}
      className="medium-modal"
      aria-labelledby="medium-modal"
    >
      <div className="medium-modal-root">
        <img
          alt="close"
          title="close"
          width="25px"
          height="25px"
          onClick={toggleModal}
          className="close-icon"
          src="/assets/icons/close-border.svg"
        />
        <div className="profile-complete-alert-modal">
          <img src={imgSrc} alt="profileCompleted" />
          <div>
            <p>{text}</p>
            <SecondaryButton
              width="100%"
              radius="10px"
              height="40px"
              text={nextText}
              handleClick={toggleModal}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ProfileCompleteAlert;
